import Style from './styles.module.scss';
import { FormDividingLineComponent } from 'src/features/generalForms/builder/types/DividingLine';

export const FormDividingLine: FormDividingLineComponent = ({}) => {
  return <div className={Style.divider} />;
};
